import type {GridColProps} from '@mantine/core';
import type {IFormFieldV2} from 'src/types/FormV2';

type FieldSize = IFormFieldV2['size'];

const SPAN_BY_SIZE: Record<NonNullable<FieldSize>, number> = {
  xs: 3,
  sm: 4,
  md: 6,
  lg: 9,
  xl: 12,
};

const getGridSpanValue = (size?: FieldSize): number =>
  size ? SPAN_BY_SIZE[size] : 12;

export type FieldGridSpan = NonNullable<GridColProps['span']>;

/** Two columns is the narrowest readable pairing between `sm` and `lg`. */
const MIN_TABLET_SPAN = 6;

/**
 * Grid.Col span for a form field: one column below `sm`, at most two up to
 * `lg`, then the configured width. Shared by `FormField`/`FormViewField`.
 */
export function useFieldGridSpan(size?: FieldSize): FieldGridSpan {
  const span = getGridSpanValue(size);
  return {base: 12, sm: Math.max(span, MIN_TABLET_SPAN), lg: span};
}
